<template>
  <div class="istore-body">
    <div class="pt-1 ps-3 istore-bread-crumbs" v-html="parentName"></div>
  </div>
  <iframe v-if="path && this.$store.state.currentMenu.url !== ''" id="appFrame" :src="path" @load="load"
                allow="clipboard-read; clipboard-write" style="height: calc(100vh - 115px);"></iframe>
</template>
<script>

import iStoreUtils from '@/scripts/istore-utils';
import imanager3Appframe from '@/scripts/imanager3-appframe';
import {langControl} from "@/scripts/istore-ui-lang";
import crypto from "@/scripts/crypto";

export default {
  name: 'AppFrame.vue',
  data() {
    return {
      token: null,
      path: null,
    }
  },
  beforeMount() {
    //window.addEventListener('message', this.onMessage)

    console.debug("pluginId:", this.$store.state.currentMenu.pluginId)

    if (this.$store.state.currentMenu.pluginId) {
      this.token = imanager3Appframe._createToken(this.$store.state.currentMenu.pluginId, this.$store.state.currentMenu.name)
    } else {
      this.token = ""
    }

    let targetURL = this.$store.state.currentMenu.url;
    if (!targetURL.startsWith('http')) {
      targetURL = `https://${location.hostname}:${location.port}/${targetURL}`
    }

    let _url = new URL(targetURL);
    if (!(location.host.includes("localhost") || location.host.includes("127.0.0.1"))
      && (_url.host.includes("localhost") || _url.host.includes("127.0.0.1"))) {
      _url.host = location.host
      _url.port = location.port
    }


    if (_url.hash === '#plugin' && _url.search) {
      // FOR TEST
      // 此功能應該 Plugin Manager 取代
      let pluginId = iStoreUtils.getUrlParamBySearch(_url.search, "pluginId")
      this.token = imanager3Appframe._createToken(pluginId, this.$store.state.currentMenu.name)
      _url.search = '?token=' + this.token + "&_t=" + Date.now()

    } else {

      // roles
      const roles = crypto.encrypt(JSON.stringify(this.$store.state.loginUser?.roles??[]))

      if (_url.search) {
        _url.search = `${_url.search}&token=${this.token}&lang=${langControl.initType}&roles=${roles}&_t=${Date.now()}`
      } else {
        _url.search = `?token=${this.token}&lang=${langControl.initType}&roles=${roles}&_t=${Date.now()}`
      }
    }

    this.path = _url.toString();
    this.path = this.path.replace(/(?<!\/)(\?)/, '/$1');

    console.debug("#[AppFrame] url :", this.path)
  },
  // move to .vue
  methods: {
    async load() {
      await imanager3Appframe.load()
    }
  },
  computed: {
    parentName() {
      const findFolderDisplayNames = (menuFunctions, parent) => {
        const tmp = []
        for (const p of parent) {
          const mf = menuFunctions.find(mf => mf.folderName === p)
          if (mf) {
            tmp.push(mf.folderDisplayName)
            menuFunctions = mf.folders
          } else {
            break
          }
        }
        return tmp
      }
      const tmp = findFolderDisplayNames(this.$store.state.menuFunctions, this.$store.state.currentMenu.parent.split('.'))
      if (tmp.length > 0) {
        return tmp.join(' / ') + ' / <span class="function-name">' + this.$store.state.currentMenu.displayName + '</span>'
      } else {
        return '<span class="function-name">' + this.$store.state.currentMenu.displayName + '</span>'
      }
    }
  }
}
</script>

<style scoped lang="scss">
iframe {
  width: 100%;
  height: 150%;
  border: none;
}

.appframe-bread-crumbs {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 10px 0 10px 30px;
}
</style>
